// src/lib/api/updateApplicantStatus.ts
import { ApplicantStatus } from '../../types/enums.js';
import { fetchWithAuth } from './fetchWithAuth';

export async function updateApplicantStatus(applicantId: string, brandId: string, orgId: string, status: ApplicantStatus, token: string) {
  return fetchWithAuth(`/api/organizations/${orgId}/brands/${brandId}/applicants/${applicantId}/status`, {
    method: 'PATCH',
    body: JSON.stringify({ status }),
    token,
  });
}